{
  "$schema": "http://json-schema.org/draft-07/schema#",
  "$id": "backoffice",
  "title": "Backoffice",
  "description": "Backoffice display preferences.",
  "type": "object",
  "properties": {
    "auto_translate_conversations": {
      "type": "boolean",
      "ui:tooltip": "Show English translations of non-English conversations by default",
      "ui:description": "When disabled, conversations appear in their original language. You can still toggle translation per conversation."
    }
  },
  "default": {
    "auto_translate_conversations": true
  }
}
